export var OptionType = /*#__PURE__*/ function(OptionType) {
    OptionType["CreateNew"] = "createNew";
    OptionType["Existing"] = "existing";
    return OptionType;
}({});
